import React from "react";
import { Card } from "react-bootstrap";
import "./Cds.css"; // Bruker samme CSS som CdsResponseComponent
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes /*, faExclamationTriangle*/ } from "@fortawesome/free-solid-svg-icons";
import parse from 'html-react-parser';
import kidneySymbolImage from './assets/nyre.png';

export const CurrentCdsComponentNyre = ({ cdsCardDataNyre, onCloseNyre }) => {

  const category = cdsCardDataNyre.extension["no.felleskatalogen.cds.nedsatt-nyre.kategori"];
  const subcategory = cdsCardDataNyre.extension["no.felleskatalogen.cds.nedsatt-nyre.underkategori"];
  const cardTitle = {
      text: `${category} - ${subcategory}`,
      iconClass: "text-warning1a" // Endre klassenavnet etter behov
  };

  // Siden vi ikke lenger filtrerer basert på alder, kan du fjerne alle de relaterte sjekkene og vise kortet direkte
  return (
    <Card className="cdsModal">
      <Card.Header>
        <img src={kidneySymbolImage} alt="Nyresymbol" className="text-kidney4" />{' '}
        <span>{cardTitle.text}</span>
        <button onClick={onCloseNyre} className="close-button">
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Card.Header>
      <Card.Body className="cdsResponseBody">
        <h4 className="cdsResponseMainTitle">{parse(cdsCardDataNyre.summary)}</h4>
        {cdsCardDataNyre.detail && <div className="cdsResponseDetail">{parse(cdsCardDataNyre.detail)}</div>}
        <div className="cdsResponseFooter">
          <div className="cdsResponseProvider">
            <span>Tjenesten leveres av</span> 
            <a href={cdsCardDataNyre.source.url} 
               target="_blank" 
               rel="noopener noreferrer"
               className="cdsResponseLink">
              {cdsCardDataNyre.source.label}
            </a>
          </div>  
        </div>
      </Card.Body>     
    </Card>
  );
};

export default CurrentCdsComponentNyre;
